import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  top: 28px;
  right: 16px;
  z-index: 2000;
  `;

export const AvatarContainer = styled.div`
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: 50%;
  `;

export const ButtonContainer = styled.div`
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: ${({ theme }) => theme.radius}px;
`;

export const PopperContainer = styled.div`
  min-width: 250px;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 4}px;
`;
